// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3qcDb","bigColWidth":"Table_bigColWidth__gMQwh","biggerColWidth":"Table_biggerColWidth__Ww8px","row":"Table_row__NJWut","col":"Table_col__37rbv"};